import "./recommendations.css";
import "@glidejs/glide/dist/css/glide.core.css";

import Glide from "@glidejs/glide";

new Glide(".cart-slider", {
    type: "carousel",
    gap: 20,
    peek: {
        before: 0,
        after: 120,
    },
}).mount();
